import { render, staticRenderFns } from "./BasePriceRow.vue?vue&type=template&id=fccb4246&scoped=true&"
import script from "./BasePriceRow.vue?vue&type=script&lang=ts&"
export * from "./BasePriceRow.vue?vue&type=script&lang=ts&"
import style0 from "./BasePriceRow.vue?vue&type=style&index=0&id=fccb4246&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fccb4246",
  null
  
)

export default component.exports